import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  DominiosTableRow,
  headersDominios,
  valoresOffcanvas,
} from './auxiliarDominios';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import DetailsTable from '../../../../../components/CustomTable/DetailsTable';
import CustomTableOffcanvas from '../../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { getAllDominios } from '../../../../../services/dominio/dominioService';
import theme from '../../../../../theme';
import { useExcelExport } from '../../../../../utils/excel-export';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateToFile,
} from '../../../../../utils/functions';
import { getSubAbas } from '../../subabas';
import { optionStatusBin } from '../utils/optionStatusBin';

const DominioListagem: React.FC = () => {
  const navigate = useNavigate();
  const user = getUser();
  const userID = user.sub;
  const [data, setData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const registros = await getAllDominios();
      setData(registros);
    } catch (error: any) {
      console.error('Erro ao buscar Cores:', error);
    }
  };
  // Buscar dados
  useEffect(() => {
    fetchData();
  }, []);

  const tableData: DominiosTableRow[] = data
    .filter((item) => item.dominioPai === null)
    .map((item) => {
      return {
        id: item?.id ?? 'Não informado',
        status: item.status === 1,
        nome: item.nome,
        descricao: item.descricao,
        filhos: item.filhos || '-',
      };
    });

  const offCanvasData = data.map((item) => {
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusDominio: (
        <span
          style={{
            backgroundColor:
              item.statusDominio === 2
                ? theme.colors.verdegov
                : theme.colors.vermelho,
            borderRadius: '10px',
            padding: '12px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            color: 'white',
          }}
        >
          {optionStatusBin[item.statusDominio]?.label}
        </span>
      ),
      dominio: item.dominio,
      descricao: item.descricao,
      separadorTipos: '',
      tiposDominios: item.tiposDominios,
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('dominio/dadosgerais');
  };

  const { exportData, isExporting } = useExcelExport('listagemdominios');
  const handleExport = async () => {
    try {
      await exportData(
        data,
        `sisaf_dominios_${formatDateToFile(new Date().toISOString())}.xlsx`,
        userID,
        'Listagem de Domínios',
        'DAF',
      );
    } catch (error) {
      console.error('Erro na exportação:', error);
    }
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);

  const handleTableRowClick = (row: DominiosTableRow) => {
    if (row?.id) {
      navigate(`dominio/${row.id}/dadosgerais`);
    }
  };

  const handleOpenDetails = (row: DominiosTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `/ficha/${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersDominios}
          data={tableData}
          displayValues={valoresOffcanvas}
          offcanvasTitle="teste"
          widthOffcanvas="60%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          emptyMessage="teste"
          filterable={true}
          showPagination={true}
          showOpenButton={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresOffcanvas}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          inserir
          onClickInserir={handleClickInserir}
          download
          onClickDownload={handleExport}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default DominioListagem;
